import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';

export interface DialogData {
  title: string;
  content: string;
  saveButtonLabel: string;
  cancelButtonLabel: string;
  rightButtonText: string;
  leftButtonText: string;
}

@Component({
  selector: 'app-dialogDate',
  templateUrl: './dialogDate.component.html',
  styleUrls: ['./dialogDate.component.scss'],
})
export class DialogDateComponent {
  formGroup!: FormGroup;
  displayEmailInput: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialog: MatDialog,
    private dialogRef: MatDialogRef<DialogDateComponent>,
    private formBuilder: FormBuilder
  ) {
    this.initializeForm();
  }

  initializeForm() {
    this.formGroup = this.formBuilder.group({
      suggestedStartDate: [''],
    });
  }

  onRightButton() {
    const selectedDate = this.formGroup.get('suggestedStartDate')?.value;
    const suggestedEndDate = selectedDate 
      ? new Date(selectedDate).toISOString()
      : new Date().toISOString(); // Usar data atual se nenhuma data foi selecionada
    
    this.dialogRef.close({
      send: true,
      suggestedEndDate: suggestedEndDate,
    });
  }

  onCancel() {
    if (this.displayEmailInput) {
      this.dialogRef.close(
        {
          send: false,
        }
      );
    } else {
      this.dialogRef.close(false);
    }
  }
  keypressDate(event: KeyboardEvent) {
    event.preventDefault();
    return;
  }
}
